import React, { useState, useEffect } from 'react';

interface OutageData {
    id: number;
    startTime: string;
    endTime: string;
    duration: number;
    region: string;
    energyLost: number;
    outageType: string;
    cause: string;
    severity: string;
    restorationEta: string;
    status: string;
}

const OutageTable: React.FC = () => {
    const [data, setData] = useState<OutageData[]>([]);

    useEffect(() => {
        // Replace with your API call
        fetch('/api/your-outage-endpoint')
            .then((response) => response.json())
            .then((data) => setData(data))
            .catch((error) => console.error('Error fetching data:', error));
    }, []);

    // Dummy data fallback
    useEffect(() => {
        if (data.length === 0) {
            const dummyData: OutageData[] = [
                {
                    id: 1,
                    startTime: '2024-12-18 02:00',
                    endTime: '2024-12-18 06:00',
                    duration: 4,
                    region: 'North Region',
                    energyLost: 500,
                    outageType: 'Unplanned',
                    cause: 'Equipment Failure',
                    severity: 'High',
                    restorationEta: '2024-12-18 06:30',
                    status: 'Resolved',
                },
                {
                    id: 2,
                    startTime: '2024-12-19 04:00',
                    endTime: '2024-12-19 05:30',
                    duration: 1.5,
                    region: 'South Region',
                    energyLost: 200,
                    outageType: 'Scheduled',
                    cause: 'Maintenance',
                    severity: 'Medium',
                    restorationEta: '2024-12-19 06:00',
                    status: 'Resolved',
                },
                {
                    id: 3,
                    startTime: '2024-12-19 08:00',
                    endTime: '2024-12-19 11:30',
                    duration: 3.5,
                    region: 'Central Region',
                    energyLost: 100,
                    outageType: 'Unplanned',
                    cause: 'Weather (Storm)',
                    severity: 'High',
                    restorationEta: '2024-12-19 12:00',
                    status: 'Active',
                },
                {
                    id: 4,
                    startTime: '2024-12-18 02:00',
                    endTime: '2024-12-18 06:00',
                    duration: 4,
                    region: 'North Region',
                    energyLost: 500,
                    outageType: 'Unplanned',
                    cause: 'Equipment Failure',
                    severity: 'High',
                    restorationEta: '2024-12-18 06:30',
                    status: 'Resolved',
                },
                {
                    id: 5,
                    startTime: '2024-12-19 04:00',
                    endTime: '2024-12-19 05:30',
                    duration: 1.5,
                    region: 'South Region',
                    energyLost: 200,
                    outageType: 'Scheduled',
                    cause: 'Maintenance',
                    severity: 'Medium',
                    restorationEta: '2024-12-19 06:00',
                    status: 'Resolved',
                },
                {
                    id: 6,
                    startTime: '2024-12-19 08:00',
                    endTime: '2024-12-19 11:30',
                    duration: 3.5,
                    region: 'Central Region',
                    energyLost: 100,
                    outageType: 'Unplanned',
                    cause: 'Weather (Storm)',
                    severity: 'High',
                    restorationEta: '2024-12-19 12:00',
                    status: 'Active',
                },
                {
                    id: 7,
                    startTime: '2024-12-18 02:00',
                    endTime: '2024-12-18 06:00',
                    duration: 4,
                    region: 'North Region',
                    energyLost: 500,
                    outageType: 'Unplanned',
                    cause: 'Equipment Failure',
                    severity: 'High',
                    restorationEta: '2024-12-18 06:30',
                    status: 'Resolved',
                },
                {
                    id: 8,
                    startTime: '2024-12-19 04:00',
                    endTime: '2024-12-19 05:30',
                    duration: 1.5,
                    region: 'South Region',
                    energyLost: 200,
                    outageType: 'Scheduled',
                    cause: 'Maintenance',
                    severity: 'Medium',
                    restorationEta: '2024-12-19 06:00',
                    status: 'Resolved',
                },
                {
                    id: 9,
                    startTime: '2024-12-19 08:00',
                    endTime: '2024-12-19 11:30',
                    duration: 3.5,
                    region: 'Central Region',
                    energyLost: 100,
                    outageType: 'Unplanned',
                    cause: 'Weather (Storm)',
                    severity: 'High',
                    restorationEta: '2024-12-19 12:00',
                    status: 'Active',
                },
                {
                    id: 10,
                    startTime: '2024-12-18 02:00',
                    endTime: '2024-12-18 06:00',
                    duration: 4,
                    region: 'North Region',
                    energyLost: 500,
                    outageType: 'Unplanned',
                    cause: 'Equipment Failure',
                    severity: 'High',
                    restorationEta: '2024-12-18 06:30',
                    status: 'Resolved',
                },
            ];
            setData(dummyData);
        }
    }, [data]);

    return (
        <div className="overflow-x-auto mt-4 mb-4 ">
            <table className="min-w-full border-collapse">
                <thead>
                    <tr className="bg-[#E7E4FF]">
                        <th className="text-sm px-2 py-1 text-gray-600 ">Outage ID</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Start Time</th>
                        <th className="text-sm px-2 py-1 text-gray-600">End Time</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Duration (hrs)</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Region</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Energy Lost (MW)</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Outage Type</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Cause</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Severity</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Restoration ETA</th>
                        <th className="text-sm px-2 py-1 text-gray-600">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={row.id} className={index % 2 === 0 ? 'bg-white' : 'bg-[#f9f9f9]'}>
                            <td className="px-2 py-1">{row.id}</td>
                            <td className="px-2 py-1">{row.startTime}</td>
                            <td className="px-2 py-1">{row.endTime}</td>
                            <td className="px-2 py-1 text-right">{row.duration.toFixed(2)}</td>
                            <td className="px-2 py-1">{row.region}</td>
                            <td className="px-2 py-1 text-right">{row.energyLost}</td>
                            <td className="px-2 py-1">{row.outageType}</td>
                            <td className="px-2 py-1">{row.cause}</td>
                            <td className="px-2 py-1">{row.severity}</td>
                            <td className="px-2 py-1">{row.restorationEta}</td>
                            <td className="px-2 py-1">{row.status}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default OutageTable;
